<template>
  <div :class="cn('animate-pulse rounded bg-gray-600', props.class)" />
</template>

<script>
import { cn } from '../../utils.js';

export default {
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return { props, cn };
  },
};
</script>
